<template>
  <div class="search" v-if="response">
    <div class="header">
      <div class="wrap-header container">
        <div class="totalResults">
          {{ response.totalPosts }} resultados encontrados
        </div>
        <div class="box align-items-center">
          <input
            type="text"
            name="term"
            v-model="term"
            v-on:keydown.enter.prevent="changeTerm"
          />
          <button class="btn" @click="changeTerm">
            <i class="icon-search"></i>
          </button>
          <div class="sort">
            <multiselect
              v-model="order"
              deselect-label
              track-by="name"
              label="name"
              placeholder="Select one"
              :options="orderOptions"
              :searchable="false"
              :allow-empty="false"
              :showPointer="false"
              :showNoResults="false"
              :showLabels="false"
              @input="changeFacet"
            ></multiselect>
          </div>
        </div>
        <div class="title">Filtros:</div>
        <div class="facets" v-if="response && response.totalPosts > 0">
          <div class="row row-cols-3">
            <div class="col">
              <label for="facet-date">Fecha</label>
              <date-picker
                name="facet-date"
                type="date"
                placeholder="Seleccione"
                range
                v-model="filterDate"
                @input="changeFacet"
              ></date-picker>
            </div>
            <div v-if="facetSections" class="col">
              <label>Sección</label>
              <multiselect
                v-model="sections"
                :options="facetSections.items"
                :multiple="true"
                :clear-on-select="false"
                :preserve-search="true"
                :taggable="false"
                placeholder="Seleccione"
                label="item"
                track-by="item"
                selectLabel="Seleccionar"
                selectedLabel="Seleccionado"
                deselectLabel="Quitar"
                openDirection="bottom"
                @input="changeFacet"
              >
                <template
                  slot="selection"
                  slot-scope="{ values, search, isOpen }"
                >
                  <span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                    >{{ values.length }} seleccionados</span
                  >
                </template>
                <template slot="tag">
                  <span></span>
                </template>
                <template slot="option" slot-scope="props">
                  <div>
                    <span>{{ props.option.item }}</span>
                    <span>({{ props.option.count }})</span>
                  </div>
                </template>
              </multiselect>
            </div>
            <div v-if="facetTags" class="col">
              <label>Tema</label>
              <multiselect
                v-model="tags"
                :options="facetTags.items"
                :multiple="true"
                :clear-on-select="false"
                :preserve-search="true"
                :taggable="false"
                placeholder="Seleccione"
                label="item"
                track-by="item"
                selectLabel="Seleccionar"
                selectedLabel="Seleccionado"
                deselectLabel="Quitar"
                openDirection="bottom"
                @input="changeFacet"
              >
                <template
                  slot="selection"
                  slot-scope="{ values, search, isOpen }"
                >
                  <span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                    >{{ values.length }} seleccionados</span
                  >
                </template>
                <template slot="tag">
                  <span></span>
                </template>
                <template slot="option" slot-scope="props">
                  <div>
                    <span>{{ props.option.item }}</span>
                    <span>({{ props.option.count }})</span>
                  </div>
                </template>
              </multiselect>
            </div>
            <div v-if="facetFeedTypes" class="col">
              <label>Tipo</label>
              <multiselect
                v-model="feedTypes"
                :options="facetFeedTypes.items"
                :multiple="true"
                :clear-on-select="false"
                :preserve-search="true"
                :taggable="false"
                placeholder="Seleccione"
                label="item"
                track-by="item"
                selectLabel="Seleccionar"
                selectedLabel="Seleccionado"
                deselectLabel="Quitar"
                openDirection="bottom"
                @input="changeFacet"
              >
                <template
                  slot="selection"
                  slot-scope="{ values, search, isOpen }"
                >
                  <span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                    >{{ values.length }} seleccionados</span
                  >
                </template>
                <template slot="tag">
                  <span></span>
                </template>
                <template slot="option" slot-scope="props">
                  <div>
                    <span>{{ props.option.item }}</span>
                    <span>({{ props.option.count }})</span>
                  </div>
                </template>
              </multiselect>
            </div>
            <div v-if="facetFormats" class="col">
              <label>Formato</label>
              <multiselect
                v-model="formats"
                :options="facetFormats.items"
                :multiple="true"
                :clear-on-select="false"
                :preserve-search="true"
                :taggable="false"
                placeholder="Seleccione"
                label="item"
                track-by="item"
                selectLabel="Seleccionar"
                selectedLabel="Seleccionado"
                deselectLabel="Quitar"
                openDirection="bottom"
                @input="changeFacet"
              >
                <template
                  slot="selection"
                  slot-scope="{ values, search, isOpen }"
                >
                  <span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                    >{{ values.length }} seleccionados</span
                  >
                </template>
                <template slot="tag">
                  <span></span>
                </template>
                <template slot="option" slot-scope="props">
                  <div>
                    <span>{{ props.option.item }}</span>
                    <span>({{ props.option.count }})</span>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
          <div class="selected-facets" v-if="hasFacetSelected">
            <span class="title">Filtros</span>
            <div v-if="filterDate && filterDate.length > 1 && filterDate[0]">
              <span class="name">Fecha:</span>
              <button class="cancel-btn" @click="removeFilterDate()">
                {{ facetDate }}
              </button>
            </div>
            <div v-if="sections && sections.length">
              <span class="name">Sección:</span>
              <button
                class="cancel-btn"
                v-for="(item, index) in sections"
                :key="item.item"
                @click="removeSection(index)"
              >
                {{ item.item }}
              </button>
            </div>
            <div v-if="tags && tags.length">
              <span class="name">Tema:</span>
              <button
                class="cancel-btn"
                v-for="(item, index) in tags"
                :key="item.item"
                @click="removeTag(index)"
              >
                {{ item.item }}
              </button>
            </div>
            <div v-if="feedTypes && feedTypes.length">
              <span class="name">Tipo:</span>
              <button
                class="cancel-btn"
                v-for="(item, index) in feedTypes"
                :key="item.item"
                @click="removeFeedType(index)"
              >
                {{ item.item }}
              </button>
            </div>
            <div v-if="formats && formats.length">
              <span class="name">Formato:</span>
              <button
                class="cancel-btn"
                v-for="(item, index) in formats"
                :key="item.item"
                @click="removeFormat(index)"
              >
                {{ item.item }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" data-mrf-recirculation="Listado de Noticias">
      <div
        class="results"
        v-if="response && response.totalPosts > 0"
        data-epica-module-name="Resultados Búsqueda"
      >
        <div class="result-list" id="sticky-anchor-1">
          <div
            class="quotes"
            v-if="quoteResponse && quoteResponse.length"
            data-epica-module-name="Resultados Búsqueda"
            data-mrf-recirculation="Indicadores"
          >
            <h5>Indicadores Relacionados</h5>
            <a
              v-for="item in quoteResponse"
              :key="item.id"
              :href="'/redirect/' + item.acType + '/' + item.id"
              class="btn"
              >{{ item.name }}</a
            >
          </div>
          <a
            :href="post.url"
            class="result"
            v-for="post in response.posts"
            :key="post.id"
          >
            <div class="info">
              <div class="d-flex iconTitle">
                <i
                  class="type"
                  v-bind:class="post.feedType"
                  :title="post.feedType"
                ></i>
                <div>
                  <div class="kicker">
                    {{ post.header }}
                    <span class="date">{{ post.createMoment }}</span>
                  </div>
                  <h3 v-html="post.title"></h3>
                  <h4 class="author">
                    <strong
                      v-for="au in post.authors"
                      :key="au"
                      v-html="au"
                    ></strong>
                  </h4>
                  <div class="sp"></div>
                  <div class="footer">
                    <div class="tags">
                      <i
                        v-if="post.tagNames && post.tagNames.length"
                        class="icon-tag"
                      ></i>
                      <span
                        v-for="(tag, index) in post.tagNames"
                        :key="index"
                        >{{ tag }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="sponsor">
          <div id="sticky-anchor-2">
            <div :id="adId"></div>
          </div>
        </div>
      </div>
      <div class="not-found" v-if="response && response.totalPosts == 0">
        <h5>Sin resultados</h5>
        <p>
          No hemos encontrado resultados relacionados a
          <strong>{{ request.term }}</strong>
        </p>
      </div>
      <div class="view-more">
        <div class="row">
          <div class="col-9">
            <button
              @click="nextPage"
              class="button mb-5"
              v-if="response.totalPosts > request.offset + request.limit"
            >
              <a class="btn analisisSect">VER MÁS</a>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/es";
import Multiselect from "vue-multiselect";
import moment from "moment";
import epica from "./../../../features/epica";
import stickyScroll from "./../../../features/sticky-scroll";
moment.locale("es-co");
export default {
  components: {
    DatePicker,
    Multiselect,
  },
  created: function () {
    this.request = Object.assign({}, sRequest);
    this.init();
    const _self = this;
    window.onpopstate = function (event) {
      if (event.state && event.state.req) {
        _self.request = JSON.parse(event.state.req);
        _self.init();
        _self.doNewSearch(true);
      } else {
        _self.request = Object.assign({}, sRequest);
        _self.init();
        _self.doNewSearch(true);
      }
    };
    this.isPostback = true;
  },
  mounted: function () {
    this.doNewSearch(true);
    stickyScroll();
  },
  updated: function () {
    const _self = this;
    epica(".search");
    if (!this.isPostback) {
      this.isPostback = true;
      googletag.cmd.push(function () {
        googletag.pubads().refresh([window.adSlots[_self.adId]]);
        this.isPostback = false;
      });
    } else {
      this.isPostback = false;
    }
  },
  methods: {
    init: function () {
      this.response = null;
      this.order = this.orderOptions.filter(
        (q) => this.request.order == q.value
      )[0];
      this.term = this.request.term;
      if (this.request.from && this.request.to) {
        this.filterDate = [
          moment(this.request.from).toDate(),
          moment(this.request.to).toDate(),
        ];
      } else {
        this.filterDate = [null, null];
      }
    },
    removeSection: function (idx) {
      this.sections.splice(idx, 1);
      this.changeFacet();
    },
    removeTag: function (idx) {
      this.tags.splice(idx, 1);
      this.changeFacet();
    },
    removeFeedType: function (idx) {
      this.feedTypes.splice(idx, 1);
      this.changeFacet();
    },
    removeFormat: function (idx) {
      this.formats.splice(idx, 1);
      this.changeFacet();
    },
    removeFilterDate: function () {
      this.filterDate = null;
      this.changeFacet();
    },
    changeFacet: function () {
      this.request.offset = 0;
      this.request.order = this.order.value;
      this.request.sections = !this.sections
        ? null
        : this.sections.map((q) => q.item);
      this.request.tags = !this.tags ? null : this.tags.map((q) => q.item);
      this.request.feedTypes = !this.feedTypes
        ? null
        : this.feedTypes.map((q) => q.item);
      this.request.formatsRaw = !this.formats
        ? null
        : this.formats.map((q) => q.item);
      if (this.filterDate && this.filterDate.length > 1 && this.filterDate[0]) {
        this.request.from = this.filterDate[0];
        this.request.to = this.filterDate[1];
      } else {
        this.request.from = null;
        this.request.to = null;
      }
      history.pushState(
        {
          req: JSON.stringify(this.request),
        },
        "",
        this.qs
      );
      this.doNewSearch();
    },
    changeTerm: function () {
      if (this.term != this.request.term && this.term) {
        this.request.term = this.term;
        this.sections = null;
        this.tags = null;
        this.formats = null;
        this.feedTypes = null;
        this.filterDate = [null, null];
        this.changeFacet();
      }
    },
    doNewSearch: function (firstTime) {
      const _self = this;
      axios
        .post("/api/search", this.request)
        .then((resp) => {
          _self.applySearch(firstTime, resp.data);
        })
        .catch((error) => {
          _self.applySearch(firstTime, error.response.data);
        });
    },
    applySearch: function (firstTime, dat) {
      this.quoteResponse = dat.quotes;
      const res = dat.standard;

      res.posts = res.posts.map((q) => {
        q.createMoment = new moment(q.create).format("MMM DD, YYYY");
        return q;
      });

      this.response = res;
      if (this.response.facets.length && firstTime) {
        this.sections = this.facetSections.items.filter((q) => q.isSelected);
        this.tags = this.facetTags.items.filter((q) => q.isSelected);
        this.feedTypes = this.facetFeedTypes.items.filter((q) => q.isSelected);
        this.formats = this.facetFormats.items.filter((q) => q.isSelected);
      }
    },
    nextPage: function () {
      const _self = this;
      this.request.offset += 10;
      axios
        .post("/api/search", this.request)
        .then((resp) => {
          const res = resp.data.standard;
          res.posts = res.posts.map((q) => {
            q.createMoment = new moment(q.create).format("MMM DD, YYYY");
            return q;
          });
          Vue.set(
            _self.response,
            "posts",
            _self.response.posts.concat(res.posts)
          );
        })
        .catch((error) => {});
    },
  },
  computed: {
    facetDate: function () {
      return this.filterDate && this.filterDate.length > 1 && this.filterDate[0]
        ? `${new moment(this.filterDate[0]).format(
            "MMM DD, YYYY"
          )} - ${new moment(this.filterDate[1]).format("MMM DD, YYYY")}`
        : null;
    },
    facetSections: function () {
      return this.response.facets.filter((q) => q.fieldName == "Section")[0];
    },
    facetTags: function () {
      return this.response.facets.filter((q) => q.fieldName == "TagNames")[0];
    },
    facetFeedTypes: function () {
      return this.response.facets.filter((q) => q.fieldName == "FeedType")[0];
    },
    facetFormats: function () {
      return this.response.facets.filter((q) => q.fieldName == "Format")[0];
    },
    hasFacetSelected: function () {
      return (
        (this.sections && this.sections.length) ||
        (this.tags && this.tags.length) ||
        (this.feedTypes && this.feedTypes.length) ||
        (this.formats && this.formats.length) ||
        (this.filterDate && this.filterDate.length > 1 && this.filterDate[0])
      );
    },
    qs: function () {
      const us = new URLSearchParams();
      if (this.request) {
        if (this.request.term) {
          us.append("term", this.request.term);
        }
        if (this.request.sections) {
          for (let i = 0; i < this.request.sections.length; i++) {
            us.append("sections", this.request.sections[i]);
          }
        }
        if (this.request.tags) {
          for (let i = 0; i < this.request.tags.length; i++) {
            us.append("tags", this.request.tags[i]);
          }
        }
        if (this.request.formatsRaw) {
          for (let i = 0; i < this.request.formatsRaw.length; i++) {
            us.append("formatsRaw", this.request.formatsRaw[i]);
          }
        }
        if (this.request.feedTypes) {
          for (let i = 0; i < this.request.feedTypes.length; i++) {
            us.append("feedTypes", this.request.feedTypes[i]);
          }
        }
        if (this.request.from) {
          us.append("from", moment(this.request.from).format());
        }
        if (this.request.to) {
          us.append("to", moment(this.request.to).format());
        }
        if (this.request.order == 0) {
          us.append("order", this.request.order);
        }
      }
      return `/buscar?${us.toString()}`;
    },
  },
  data: function () {
    return {
      response: null,
      quoteResponse: null,
      request: null,
      filterDate: [],
      sections: null,
      tags: null,
      feedTypes: null,
      formats: null,
      order: null,
      term: null,
      adId: "div-gpt-ad-5",
      orderOptions: [
        { name: "Ordenar por más reciente", value: 1 },
        { name: "Ordenar por más antiguo", value: 0 },
      ],
    };
  },
};
</script>
